import { render, staticRenderFns } from "./LuckyHistory.vue?vue&type=template&id=4d9ef2b3&scoped=true&"
import script from "./LuckyHistory.vue?vue&type=script&lang=js&"
export * from "./LuckyHistory.vue?vue&type=script&lang=js&"
import style0 from "./LuckyHistory.vue?vue&type=style&index=0&id=4d9ef2b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9ef2b3",
  null
  
)

export default component.exports